import React from 'react'

const Header = () => {
  return (
    <header>
      <img src='/images/Adhoc_Logo_Azul.svg' alt='Agencia Adhoc'/>
    </header>
  )
}

export default Header
